import React from 'react';
import { routes } from '../../containers/routes/routes-names';
import { Link } from 'react-router-dom';
import websitelogo from '../../assets/img/offerx-logo.svg';

const SignUpHeader = () => {
    return (
        <div>
            <header className="landing-page">
                <nav className="navbar navbar-expand-lg navbar-toggleable-sm navbar-light py-0">
                    <div className="container">
                        <Link to={routes.main} className="navbar-brand py-0 fs-28 fw-700">
                            <img src={websitelogo} className="site-logo" alt="OfferX Logo"></img>
                        </Link>
                        <button
                            className="navbar-toggler border-0"
                            type="button"
                            data-bs-target="#offcanvasNavbar"
                            data-bs-toggle="offcanvas"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div
                            className="flex-sm-row-reverse offcanvas offcanvas-end"
                            id="offcanvasNavbar"
                            data-bs-scroll="true"
                            tabIndex={0}
                        >
                            <div className="offcanvas-header ml-auto">
                                <button
                                    data-sider-close
                                    aria-label="Close"
                                    className="btn-close text-reset ms-auto"
                                    data-bs-dismiss="offcanvas"
                                    type="button"
                                />
                            </div>
                            <div className="offcanvas-body mobile-offcanvas">
                                <ul className="navbar-nav flex-grow">
                                    <li className="nav-item">
                                        <a
                                            target="_blank"
                                            href={routes.contact}
                                            className="nav-link lt-text-footer text-decoration-underline"
                                            tabIndex={0}
                                            title="Contact Us"
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <i className="bi bi-headset fs-20"></i>
                                                </div>
                                                <div>Contact Us</div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        </div>
    );
};

export default SignUpHeader;
